import * as React from "react"
import { Check } from "lucide-react"
import { cn } from "@/lib/utils"

const Checkbox = React.forwardRef(({ className, checked, defaultChecked, onCheckedChange, disabled, id, ...props }, ref) => {
  const [isChecked, setIsChecked] = React.useState(defaultChecked || false);
  const controlled = checked !== undefined;
  const currentChecked = controlled ? checked : isChecked;

  const handleClick = () => {
    if (disabled) return;
    const next = !currentChecked;
    if (!controlled) setIsChecked(next);
    if (onCheckedChange) onCheckedChange(next);
  };

  return (
    <button
      ref={ref}
      type="button"
      role="checkbox"
      aria-checked={currentChecked}
      id={id}
      disabled={disabled}
      data-state={currentChecked ? "checked" : "unchecked"}
      className={cn(
        "peer h-4 w-4 shrink-0 rounded-sm border border-primary shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
        className
      )}
      onClick={handleClick}
      {...props}
    >
      {currentChecked && (
        <span className="flex items-center justify-center text-current">
          <Check className="h-4 w-4" />
        </span>
      )}
    </button>
  );
});
Checkbox.displayName = "Checkbox";

export { Checkbox }
